/*
Use this file to define all the API Urls for your application.
*/

// Home Items
export const bffActivePendingItemsUrl = (id: string): string => {
  return `api/v3/active_pending_medications/${id}`;
};

export const bffActiveHomeItemsUrl = (id: string): string => {
  return `api/v3/active_home_items/${id}`;
};

// Cart
export const bffCartUrl = (cartId: string): string => `api/v2/carts/${cartId}`;

export const bffCreateCartUrl = (): string => {
  return `api/v2/carts?shouldPrefill=true`;
};

export const bffCheckoutCartUrl = (cartId: string): string => {
  return `api/v2/carts/${cartId}/checkout`;
};

// Over The Counter (OTC) Medications
export const bffGetOTCItemsUrl = (accountId: string): string => {
  return `api/otcs/${accountId}`;
};

// Orders
export const ordersUrl = (): string => {
  return `api/v2/orders`;
};

export const bffGetOrderDetailUrl = (orderId: string): string => {
  return `api/v2/orders/${orderId}`;
};

export const bffGetRescheduledDeliveryWindowsForOrder = (orderId: string): string => {
  return `api/v2/orders/${orderId}/reschedule/delivery_windows`;
};

export const bffGetOrderIdFromShortCodeUrl = (shortCode: string): string => {
  return `/api/v2/orders/${shortCode}/short_code`;
};

// Insurance
export const postInsuranceCardUrl = (primaryPatientId: string): string => {
  return `api/insurance/${primaryPatientId}/upload`;
};

// Onboarding
export const checkZipCodeEligibilityUrl = (zipCode: string): string => {
  return `api/delivery_availability/zip_code/${zipCode}`;
};

export const checkEmailAvailabilityUrl = (): string => {
  return `api/accounts/email_check`;
};

/**
 * @deprecated: use useSearchMedication hook instead.
 */
export const getMedicationsV3Url = (searchTerm: string, zipCode?: string): string => {
  return `api/v3/medications/search?searchTerm=${searchTerm}${zipCode ? `&zipCode=${zipCode}` : ``}`;
};

export const onboardingUrl = (): string => {
  return `api/onboarding/account_transfers`;
};

export const onboardingWithMatchUrl = (): string => {
  return `api/onboarding/onboarding_with_match`;
};

export const onboardingValidateUrl = (): string => {
  return `api/onboarding/validate`;
};

export const notifyTransferUrl = (accountId: string): string => {
  return `api/accounts/${accountId}/notify_transfer`;
};
